import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetch active clone categories (public, sorted by sort_order). Fresh on each mount.
export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let alive = true;
    api
      .get("/categories")
      .then(({ data }) => alive && setCategories(Array.isArray(data) ? data : []))
      .catch(() => alive && setCategories([]));
    return () => {
      alive = false;
    };
  }, []);
  return categories;
};
